// extracted by mini-css-extract-plugin
export default {"formQuestion":"FormQuestionCard_formQuestion__lhpEz","formQuestionFields":"FormQuestionCard_formQuestionFields__+ITeQ","hideSpinners":"FormQuestionCard_hideSpinners__xGjh6"};